module.exports = __webpack_public_path__ + "static/media/carta_34.5e779474.jpg";